:host {
    display: block;
}
i {
    width: 50px;
    height: 50px;
    display: flex !important;
    align-items: center;
    justify-content: center;
}
.contact-avatar [data-letters]::before {
    font-size: 20px !important;
    margin-right: unset !important;
    width: 50px !important;
    height: 50px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
}